import { classes } from '~/helpers';
import { HTMLCustomElement } from '~/html-custom-element';

export class ContentTabs extends HTMLCustomElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    this.targets.button && this.on('click', this.targets.button.all, this.handleButtonEvent.bind(this));

    /**
     * Set the first tab as active.
     */
    this.targets.tab && this.setCurrentTab(this.targets.tab.all[0].dataset.tab);
  }

  handleButtonEvent(event) {
    this.setCurrentTab(event.currentTarget.dataset.tab);
  }

  setCurrentTab(id) {
    /**
     * Sets the given element's active state.
     * @param {HTMLElement} element - The tab element.
     */
    function setElementState(element) {
      if (element.dataset.tab === id) {
        element.classList.add(classes.active);
        return;
      }

      element.classList.remove(classes.active);
    }

    this.targets.button && this.targets.button.all.forEach(setElementState);
    this.targets.tab && this.targets.tab.all.forEach(setElementState);
  }
}
